export default __webpack_public_path__ + "static/media/devX_launchpad.97f5267a.svg";